import { render, staticRenderFns } from "./MobileComponent.vue?vue&type=template&id=3018884d&scoped=true&"
import script from "./MobileComponent.vue?vue&type=script&lang=js&"
export * from "./MobileComponent.vue?vue&type=script&lang=js&"
import style0 from "./MobileComponent.vue?vue&type=style&index=0&id=3018884d&lang=scss&scoped=true&"
import style1 from "./MobileComponent.vue?vue&type=style&index=1&id=3018884d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3018884d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VDatePicker,VIcon,VImg,VMenu,VRadio,VRadioGroup,VTextField,VTextarea})
